// extracted by mini-css-extract-plugin
export default {"events-summary-error":"styles_events-summary-error__IZel+"};